
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { FormValues } from "@/types/loan";

interface PersonalBasicInfoFieldsHeProps {
  form: UseFormReturn<FormValues>;
}

export const PersonalBasicInfoFieldsHe = ({ form }: PersonalBasicInfoFieldsHeProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <FormField
        control={form.control}
        name="firstName"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-gray-700 text-right block text-xs sm:text-sm">שם פרטי</FormLabel>
            <FormControl>
              <Input 
                placeholder="שם פרטי" 
                className="bg-white text-right border-blue-200 focus:border-blue-400 transition-colors text-xs sm:text-sm h-8 sm:h-10" 
                {...field} 
              />
            </FormControl>
            <FormMessage className="text-right" />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="lastName"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-gray-700 text-right block text-xs sm:text-sm">שם משפחה</FormLabel>
            <FormControl>
              <Input 
                placeholder="שם משפחה" 
                className="bg-white text-right border-blue-200 focus:border-blue-400 transition-colors text-xs sm:text-sm h-8 sm:h-10" 
                {...field} 
              />
            </FormControl>
            <FormMessage className="text-right" />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="email"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-gray-700 text-right block text-xs sm:text-sm">דוא"ל</FormLabel>
            <FormControl>
              <Input 
                type="email" 
                placeholder="your.email@example.com" 
                className="bg-white border-blue-200 focus:border-blue-400 transition-colors text-xs sm:text-sm h-8 sm:h-10" 
                {...field} 
              />
            </FormControl>
            <FormMessage className="text-right" />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="phoneNumber"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-gray-700 text-right block text-xs sm:text-sm">מספר טלפון</FormLabel>
            <FormControl>
              <Input 
                type="tel" 
                placeholder="+358 40 123 4567" 
                className="bg-white border-blue-200 focus:border-blue-400 transition-colors text-xs sm:text-sm h-8 sm:h-10" 
                {...field} 
              />
            </FormControl>
            <FormMessage className="text-right" />
          </FormItem>
        )}
      />
    </div>
  );
};
